import React from 'react';
import { TPropertiesOfPatchChangesForSubcategory } from 'types';
import OutsideFormInput from 'components/Input/OutsideFormInput';
import CronGenerator from 'components/CronGenerator/CronGenerator';
import { Checkbox } from 'antd';
import Text from 'components/Text/Text';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import classNames from 'classnames';
import style from './Cron.module.scss';

interface IProps {
	changeActivationSchedule(value: string): void;
	changeDeactivationSchedule(value: string): void;
	toggleAvailableForRepetition(): void;
	toggleIsHidden(): void;
	selectedProperties: TPropertiesOfPatchChangesForSubcategory[];
	activationSchedule: string;
	deactivationSchedule: string;
	availableForRepetition: boolean;
	isHidden: boolean;
	hasSchedulePriority: boolean;
}

export const Cron: React.FC<IProps> = ({
	changeActivationSchedule,
	changeDeactivationSchedule,
	toggleAvailableForRepetition,
	toggleIsHidden,
	selectedProperties,
	activationSchedule,
	deactivationSchedule,
	availableForRepetition,
	isHidden,
	hasSchedulePriority,
}) => {
	const checkboxWrapperClasses = classNames(style.row, style.checkboxesWrapper);

	return (
		<div className={style.container}>
			{selectedProperties.some(
				(selectedProperty) =>
					selectedProperty === 'availableForRepetition' || selectedProperty === 'hideSubcategory',
			) && (
				<div className={checkboxWrapperClasses}>
					{selectedProperties.includes('availableForRepetition') && (
						<div className={style.input}>
							<Text
								translationNameSpace="form"
								translationKey="availableForRepetitionHeading"
								size="xs"
							/>
							<Checkbox onChange={toggleAvailableForRepetition} checked={availableForRepetition}>
								<Text translationNameSpace="form" translationKey="availableLabel" asFragment={true} />
							</Checkbox>
						</div>
					)}
					{selectedProperties.includes('hideSubcategory') && (
						<div className={style.input}>
							<Text translationNameSpace="form" translationKey="hideSubcategoryHeading" size="xs" />
							<Checkbox onChange={toggleIsHidden} checked={isHidden}>
								<Text translationNameSpace="form" translationKey="isHiddenLabel" asFragment={true} />
							</Checkbox>
						</div>
					)}
				</div>
			)}

			{selectedProperties.some(
				(selectedProperty) => selectedProperty === 'activation' || selectedProperty === 'deactivation',
			) && (
				<>
					<div className={style.row}>
						{selectedProperties.includes('activation') && (
							<OutsideFormInput
								containerClassName={style.input}
								testId="ActivationScheduleInput"
								name="activationSchedule"
								label="activationScheduleLabel"
								placeholder="cronExpressionInputPlaceholder"
								maxLength={255}
								value={activationSchedule}
								onChange={changeActivationSchedule}
							/>
						)}
						{selectedProperties.includes('deactivation') && (
							<OutsideFormInput
								containerClassName={style.input}
								testId="DeactivationScheduleInput"
								name="deactivationSchedule"
								label="deactivationScheduleLabel"
								placeholder="cronExpressionInputPlaceholder"
								maxLength={255}
								value={deactivationSchedule}
								onChange={changeDeactivationSchedule}
							/>
						)}
					</div>
					<CronGenerator />
				</>
			)}

			{selectedProperties.some((selectedProperty) => ['activation', 'deactivation'].includes(selectedProperty)) &&
				hasSchedulePriority && (
					<div className={style.infoWrapper}>
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#circleInfoTransparent`} />
						</svg>
						<Text
							translationNameSpace="form"
							translationKey="warningSubcategorySchedule"
							theme="secondary"
							size="s"
							display="inline"
						/>
					</div>
				)}
		</div>
	);
};
